module.exports = __webpack_public_path__ + "static/media/textImage123px.fac52c81.svg";